// extracted by css-extract-rspack-plugin
export default {"sidebar":"GoErB _79NX","item":"S1OjO _Uhde PsTpS cahH4 lyZjJ","icon":"zUGV9","selected":"FQXyb","name":"VVdYR SJXBn ygoQK"};